<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="11.7" stroke="#FFFFFF" stroke-width="0.6"/>
<path d="M8.875 6.375L17.625 12L8.875 17.625V6.375Z" fill="#FFFFFF" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
